import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu']

  connect() {
    this.closeAllMenus()
    document.addEventListener('click', this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()

    const isOpen = !this.menuTarget.classList.contains('hidden')
    this.closeAllMenus()

    if (!isOpen) {
      this.menuTarget.classList.remove('hidden')
    }
  }

  handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add('hidden')
    }
  }

  closeAllMenus(except = null) {
    document
      .querySelectorAll("[data-dropdown-menu-target='menu']")
      .forEach((menu) => {
        if (menu !== except) {
          menu.classList.add('hidden')
        }
      })
  }
}
